import {
    AddressModel,
    CseDopModel,
    DisplayDecorator,
    isDefined,
    MATERIAL_SOURCE_CODE,
    MaterialCentralReturnModel,
    MaterialModel,
    MaterialUtilitiesService,
    NotificationIdentifierModel,
} from '@evorait/pace-core';
import MaterialReturnP58Model from '../material-return-p58/material-return-p58.model';

export default class MaterialReturnBootstockModel extends MaterialReturnP58Model {
    public constructor(
        material: MaterialModel,
        cseDopList: Array<DisplayDecorator<CseDopModel>>,
        materialUtilities: MaterialUtilitiesService,
        frontId: string,
        isBootstockReturn: boolean,
    ) {
        // For bootstock, always create a new NotificationIdentifierModel
        // Bootstock materials don't have notification.
        const notificationIdentifier = new NotificationIdentifierModel(frontId, '', '');

        if (!material.notificationIdentifier) {
            material.notificationIdentifier = notificationIdentifier;
        }

        // customerAddress is added from notification and bootstock does not have notification
        if (!material.customerAddress) {
            material.customerAddress = AddressModel.build({ name1: '' });
        }

        material.noPhysicalReturn = false; // Bootstock returns noPhysicalReturn is always false.
        material.isBootstockReturn = isBootstockReturn;
        material.isBootStockScrapable = !isBootstockReturn; // If it's not return, then it's scrap, and it should be scrappable as per snowflake.
        material.materialSource.sourceCode = MATERIAL_SOURCE_CODE.BOOTSTOCK;
        material.isBootstockMaterial = true; // Cache the bootstock flag for template performance

        // Bootstock-specific logic: Create MaterialCentralReturnModel from the passed material for MaterialReturnP58Model
        const materialCentralReturn = new MaterialCentralReturnModel(
            material,
            notificationIdentifier,
            cseDopList,
            materialUtilities,
        );

        // setting up options for quantity stepper based on the material's deliveredQuantity
        // required: true and minValue: 1 ensure the form is invalid when quantity < 1
        // maxValue uses deliveredQuantity to match the "Actual Quantity" shown to the user
        const minQuantity = material.quantity.options.minValue > 0 ? material.quantity.options.minValue : 1;
        materialCentralReturn.selectedPartSet.quantity.options = {
            ...materialCentralReturn.selectedPartSet.quantity.options,
            maxValue: material.deliveredQuantity,
            minValue: minQuantity,
            required: true,
            readonly: false, // Bootstock quantity should be editable
        };
        const materialReturnList = [materialCentralReturn];

        // Call parent constructor with the prepared material return list
        super(materialReturnList);

        // Set up AWB return label for bootstock return
        if (isDefined(this.awbReturnLabel)) {
            this.materialReturnList[0].selectedPartSet.returnLabel = this.awbReturnLabel;
        }
    }
}
